import React from "react";
import { Spinner } from "reactstrap";
import { useLocation } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { FaGlobe } from "react-icons/fa";
import NAIMAGE from "../../../../static/NA.png";

import { getCamelCaseWord } from "../../../../static/brands_wholesalers_data";

const ProfileDetailItem = ({ title, data, onClick, main, isAggregated }) => {
  const { state } = useLocation();
  const mainItem = data?.find((item) => item?.label === main);
  const displayItem =
    mainItem || (data?.length > 0 && data[0] !== undefined ? data[0] : null);

  const firstItemLabel = displayItem?.label;
  const firstItemImage = displayItem?.imageWhite || displayItem?.image;
  const firstItemCountryCode = displayItem?.code;

  return (
    <div className="flex-grow-1 mb-3">
      <h6 className="font-weight-bold text-truncate">
        {title === "Wholesale Type" && state?.brand
          ? "Preferred Wholesaler Type"
          : title}
      </h6>
      <hr className="my-2" />
      <div
        className="d-flex flex-column justify-content-center align-items-center position-relative"
        style={{
          minWidth: "230px",
          width: "100%",
          height: "220px",
          borderRadius: "12px",
          gap: "21px",
          backgroundColor: mainItem ? "#E3C2A8" : "#000",
          cursor: "pointer", // Ensures it behaves like a button
        }}
        onClick={onClick}
      >
        {isAggregated && (
          <div
            style={{
              top: "10px",
              left: "10px",
              position: "absolute",
              padding: "3px 10px",
              borderRadius: "12px",
              fontSize: "11px",
              fontWeight: "bold",
              color: "#fff",
              backgroundColor: "#e8b009",
              boxShadow: "0 1px 4px rgba(0,0,0,0.35)",
              zIndex: 1,
            }}
          >
            Aggregated
          </div>
        )}
        {firstItemLabel ? (
          <>
            {firstItemImage ? (
              <img
                src={firstItemImage}
                alt="Brand"
                style={{ width: "90px", maxHeight: "150px" }}
              />
            ) : (
              <>
                {firstItemCountryCode === "OP" ? (
                  <FaGlobe size={60} color="white" />
                ) : firstItemCountryCode ? (
                  <ReactCountryFlag
                    countryCode={firstItemCountryCode}
                    svg
                    style={{
                      width: "70px",
                      height: "70px",
                    }}
                  />
                ) : (
                  <img
                    src={NAIMAGE}
                    alt="Brand"
                    style={{ width: "90px", maxHeight: "150px" }}
                  />
                )}
              </>
            )}
            <p
              className="font-weight-bold mb-0"
              style={{
                color: mainItem ? "#000" : "#fff",
              }}
            >
              {getCamelCaseWord(firstItemLabel)}
            </p>
            {data?.length > 1 && (
              <div
                style={{
                  top: "-10px",
                  right: "0",
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#E2AD82",
                  position: "absolute",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p className="text-white mb-0">+{data?.length - 1}</p>
              </div>
            )}
          </>
        ) : data[0] === "no data" ? (
          <p className="text-white mb-0">no data</p>
        ) : (
          <div className="d-flex align-items-center gap-2">
            <Spinner style={{ color: "#fff", width: "20px", height: "20px" }} />
            <p className="text-white mb-0">Fetching</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileDetailItem;
